module.exports = __webpack_public_path__ + "img/9_70.8429accc.png";